var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHorizontalDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 4,
    viewBox: "0 0 20 4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187110",
    "data-name": "Group 187110",
    transform: "translate(-442 -269)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_247",
    "data-name": "Ellipse 247",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(458 269)",
    fill: "#9c9b9a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_248",
    "data-name": "Ellipse 248",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(450 269)",
    fill: "#9c9b9a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_249",
    "data-name": "Ellipse 249",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(442 269)",
    fill: "#9c9b9a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalDots);
export default __webpack_public_path__ + "static/media/horizontal-dots.bc99416aa58a7aca1f1bc1256c8ed208.svg";
export { ForwardRef as ReactComponent };